import { render, staticRenderFns } from "./EikenScoreComponent.vue?vue&type=template&id=3a0dd6d2&scoped=true&"
import script from "./EikenScoreComponent.vue?vue&type=script&lang=js&"
export * from "./EikenScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./EikenScoreComponent.vue?vue&type=style&index=0&id=3a0dd6d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0dd6d2",
  null
  
)

export default component.exports